const s = class s extends HTMLElement {
  constructor() {
    super(...arguments), this.handleDismiss = () => {
      s.dismiss(), this.classList.add("hidden");
    };
  }
  connectedCallback() {
    var t;
    if (s.isDismissed() || s.wasNewsletterSubmittedSuccessfully()) {
      s.dismiss();
      return;
    }
    this.classList.remove("hidden"), this.dismissButton = this.querySelector("[newsletter-dismiss]"), (t = this.dismissButton) == null || t.addEventListener("click", this.handleDismiss);
  }
  disconnectedCallback() {
    var t;
    (t = this.dismissButton) == null || t.removeEventListener("click", this.handleDismiss);
  }
  static isDismissed() {
    try {
      return localStorage.getItem(s.STORAGE_KEY) === "true";
    } catch {
      return !1;
    }
  }
  static dismiss() {
    try {
      localStorage.setItem(s.STORAGE_KEY, "true");
    } catch {
    }
  }
  static wasNewsletterSubmittedSuccessfully() {
    return new URLSearchParams(window.location.search).get("customer_posted") === "true";
  }
};
s.STORAGE_KEY = "newsletterTeaserDismissed";
let e = s;
window.customElements.define("newsletter-teaser", e);
export {
  e as NewsletterTeaser
};
